/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class CertExamExamRecognition extends Ce {
    constructor() {
        super();
        this.baseUrl += '/certExamExamRecognition';
    }

    data({
        fullName,
        idCardNo,
        mobile,
        userName,
        examName,
        certCatId,
        certExamType,
        verticalGroupingName,
        examResult,
        classExaminationType,
        examNotPassType,
        recognitionResult,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        return super.get('/data', {
            fullName,
            idCardNo,
            mobile,
            userName,
            examName,
            certCatId,
            certExamType,
            verticalGroupingName,
            examResult,
            classExaminationType,
            examNotPassType,
            recognitionResult,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }

    release({ ids } = {}) {
        return super.post('/release', {
            ids,
        });
    }
}

export default new CertExamExamRecognition();
export { CertExamExamRecognition };
